module.exports = __webpack_public_path__ + "static/img/icon_jga.fd115ec2.png";